import type { Resource } from 'i18next';
import type { I18nInstance } from '../types/i18n';

/**
 * Merges `translations` onto an already-initialized i18next instance without
 * changing its current language or overwriting existing resource bundles.
 */
export function addNamespaceResources(
  instance: Pick<I18nInstance, 'addResourceBundle' | 'setDefaultNamespace'>,
  translations: Resource,
  defaultNamespace?: string
): void {
  // if initialized, then dont change default, but add new name space with resources.
  Object.entries(translations).forEach(([language, resource]) => {
    Object.keys(resource).forEach((namespace) => {
      try {
        instance.addResourceBundle(
          language,
          namespace,
          resource[namespace],
          true,
          true
        );
      } catch (error) {
        console.warn(
          `I18n resources for namespace "${namespace}" and language "${language}" couldn't load: ${error}`
        );
      }
    });
  });
  if (defaultNamespace) {
    instance.setDefaultNamespace(defaultNamespace);
  }
}
